import { lazy, Suspense } from "react";
import PageLayout from "@/components/PageLayout";
import PageMeta from "@/components/PageMeta";
import Hero from "@/components/sections/Hero";
import AboutDocm from "@/components/sections/AboutDocm";
import PrinciplesWheel from "@/components/sections/PrinciplesWheel";
import Summit0808Teaser from "@/components/sections/Summit0808Teaser";
import LandingActZone from "@/components/sections/LandingActZone";
import TwoPathways from "@/components/sections/TwoPathways";
import { DirectoryHome } from "@/components/directory/DirectoryHome";

// Below-the-fold sections load lazily.
const SignDeclaration = lazy(() => import("@/components/sections/SignDeclaration"));

const Blank = () => <div style={{ minHeight: "60vh" }} />;

// Streamlined home page — Feb 2026 strategic re-order per Tiger's review:
// Hero (2 CTAs only) → Movement Explainer (AboutDocm) → 9 Principles preview
// → Random Acts action zone + live carousel → 11·11 teaser → Two Pathways
// (Ambassadors + Partners) → Sign the Declaration.
export default function Home() {
  return (
    <PageLayout>
      <PageMeta
        title="Declare Consciousness. Do one act of goodness. Uplift humanity."
        description="A global movement that turns awareness into action. Sign the Declaration, perform one Random Act of Consciousness, and join the world on 11·11 — Consciousness Day for Humanity."
        path="/"
        image="https://signdc.org/og-image.jpg"
      />
      <Hero />
      <AboutDocm />
      <PrinciplesWheel />
      <LandingActZone testidPrefix="home-act-zone" />
      <DirectoryHome />
      <Summit0808Teaser />
      <TwoPathways />
      <Suspense fallback={<Blank />}>
        <SignDeclaration />
      </Suspense>
    </PageLayout>
  );
}
